import React from "react";
import { Dialog, Flex, Text, TextField, Button } from "@radix-ui/themes";

export function AuthLeatDialog({
  isOpen,
  onOpenChange,
  onCancel,
  onSave,
  handleApiTokenChange,
  isApiTokenValid,
  isLoading,
  title = "Connect Leat",
}) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="600px" maxHeight="690px" align="center">
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          To find your Personal Access Token, log into the Leat Business Dashboard and go to
          Apps → Integrations → Create private app. Under the General tab, give the app a name.
          Then open the Auth tab, create a Personal Access Token, choose how long it should last,
          and copy the token when it is shown (it will not be shown again). Submit to finish
          creating the app, then paste the token below.
        </Dialog.Description>

        <Flex
          className="slot-container"
          style={{ paddingTop: "14px", alignSelf: "stretch" }}
          display="flex"
          direction="row"
          align="start"
          gap="5"
        >
          <Flex
            className="api-key-field"
            style={{ flex: 1 }}
            display="flex"
            direction="column"
            align="start"
            gap="1"
          >
            <Text size="2" weight="medium">
              Personal Access Token
            </Text>
            <TextField.Root
              onChange={handleApiTokenChange}
              placeholder="Paste your Leat Personal Access Token here"
              style={{ width: "100%" }}
              size="2"
              variant="surface"
            />
            {!isApiTokenValid && (
              <Text size="1" weight="regular" color="red">
                Please enter a valid Personal Access Token.
              </Text>
            )}
          </Flex>
        </Flex>

        <Flex
          style={{
            alignSelf: "stretch",
            width: "100%",
          }}
          display="flex"
          justify="end"
          align="center"
          mt="4"
          gap="3"
        >
          <Dialog.Close>
            <Button onClick={onCancel} size="2" variant="soft" color="gray">
              Cancel
            </Button>
          </Dialog.Close>
          <Button
            onClick={() => onSave()}
            size="2"
            variant="soft"
            color="accent"
            loading={isLoading}
          >
            Save and continue
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
